// These types have been taken from jira-frontend to ensure the colour data return gets mapped correctly for the lozenge
export var appearanceMap = {
  BLUE_GRAY: 'default',
  MEDIUM_GRAY: 'default',
  BROWN: 'default',
  GREEN: 'success',
  YELLOW: 'inprogress',
  WARM_RED: 'removed'
};